import React from 'react'

interface Props {}

const Stock = (props: Props) => {
  return (
    <div>Stock</div>
  )
}

export default Stock